import { useParams } from 'react-router-dom';
import { TransactionChats } from '@ui/src';
import { useAppSelector } from '@store';
import useProblemExchangeTransaction from '../hooks/use-exchange';

const ExchangeTransactionChats = (): React.JSX.Element => {
  const { chats, transaction, senderCompanyOfficials } = useAppSelector(
    (state) => state.customersProblemTransactions.exchange,
  );
  const { currentEmployee } = useAppSelector(
    (state) => state.customersDictionaries,
  );
  const { currencies: currenciesList, activePermissions } = useAppSelector(
    (state) => state.root,
  );

  const { transactionId } = useParams();

  const { onCreateTransactionChat, chatCreateInProgress } =
    useProblemExchangeTransaction({
      transaction,
      transactionId,
      currenciesList,
      currentEmployee,
    });

  return (
    <TransactionChats
      chats={chats}
      companyOfficials={senderCompanyOfficials}
      individualCustomer={transaction?.senderAccount}
      onCreateTransactionChat={onCreateTransactionChat}
      chatCreateInProgress={chatCreateInProgress}
      currentEmployee={currentEmployee}
      activePermissions={activePermissions}
    />
  );
};

export default ExchangeTransactionChats;
